import { render, staticRenderFns } from "./purchase.index.vue?vue&type=template&id=4d635b26&"
import script from "./purchase.index.vue?vue&type=script&lang=js&"
export * from "./purchase.index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports